import checkObjectType from './_helpers/checkobjecttype.js';
import forOwn from './_helpers/forown.js';
import forEach from './_helpers/foreach.js';
import assign from './_helpers/assign.js';
import mediate from './mediate.js';
// the function is used when no update function is given
function defaultUpdateFunction(instance, data) {
  if (instance.isMatreshkaArray) {
    instance.recreate(data);
  } else if (instance.isMatreshkaObject) {
    // take only data keys of an assigned Matreshka.Object, not its service properties
    instance.setData(data != null && data.isMatreshkaObject ? data.toJSON(false) : data, {
      replaceData: true
    });
  } else {
    // for other objects just extend them with given data
    assign(instance, data);
  }
}
// returns mediator which controls assignments
function createInstantiateMediator(_ref) {
  var UsedClass = _ref.UsedClass,
    updateFunction = _ref.updateFunction;
  return function mediator(value, previousValue, key, object) {
    if (previousValue instanceof UsedClass) {
      updateFunction.call(object, previousValue, value, key);
      return previousValue;
    }
    return new UsedClass(value, object, key);
  };
}
export default function instantiate(object, givenKeys, UsedClass, givenUpdateFunction) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    givenUpdateFunction = UsedClass;
    UsedClass = givenKeys;
    givenKeys = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'instantiate');
  }
  var isKeysArray = Array.isArray(givenKeys);
  // allow to use key-class object
  if (typeof givenKeys === 'object' && !isKeysArray) {
    forOwn(givenKeys, function (objVal, objKey) {
      return instantiate(object, objKey, objVal, UsedClass);
    });
    return object;
  }
  // allow to use both single key and an array of keys
  var keys = isKeysArray ? givenKeys : [givenKeys];
  var updateFunction = givenUpdateFunction || defaultUpdateFunction;
  var mediator = createInstantiateMediator({
    UsedClass: UsedClass,
    updateFunction: updateFunction
  });
  // iterate over all keys and define created mediator for all of them
  forEach(keys, function (key) {
    return mediate(object, key, mediator);
  });
  return object;
}